export const home = {
  'Made for': 'Feito para',
  'New releases': 'Novos lançamentos',
  MUSIC: 'Música',
  ALL: 'Todos',
  PODCASTS: 'Podcasts',
  FOLLOWING: 'Seguindo',
  'Podcast following title': 'Você ainda não segue nenhum podcast',
  'Podcast following description': 'Siga seus podcasts favoritos para ficar por dentro.',
  'Explore podcasts': 'Explorar podcasts',
  'More like': 'Mais como',
  'Episodes you might like': 'Episódios que você pode gostar',
  'Episodes to try': 'Episódios para experimentar',
  ARTISTS: 'Artistas',
  SONGS: 'Músicas',
  ALBUMS: 'Álbuns',
  TRACKS: 'Músicas',
  PLAYLISTS: 'Playlists',
  you: 'você',
  'Made for you': 'Feito para você',
};
